export const DELETE = 'delete';